// map of frontend sort keys to their backend equivalent
const SORT_KEY_MAP: Record<string, string> = {
  name: 'name',
  updated_on: 'updatedAt',
};

/**
 * This function translates a frontend `sort` param to the backend format.
 *
 * The `sort` query param we display to the user in the frontend isn't
 * understood by the packages backend, so we need to translate it to the
 * correct format.
 *
 * The `sort` param in the frontend:
 *  - uses the **API response** field name
 *  - uses a `-` prefix to denote a descending sort order
 *  - examples: `-name`, `updated_on`
 *
 * Whereas the `sort` param in the backend:
 *  - uses the field name of the **DB entity** being queried
 *  - uses `asc|desc` to denote sort order
 *  - examples: `name,desc`, `updated_on,asc`
 *
 * @param param the `sort` param to translate
 * @returns the translated `sort` param, or an empty string if `param` has no
 * valid translation
 */
export const translateSortParam = (param: string): string => {
  if (!param) {
    return '';
  }

  const sortDirection = param.startsWith('-') ? 'desc' : 'asc';
  const clientSortKey = param.startsWith('-') ? param.substring(1) : param;
  const apiSortKey = SORT_KEY_MAP[clientSortKey];
  if (apiSortKey === undefined) {
    return '';
  }

  return `${apiSortKey},${sortDirection}`;
};
